export default __webpack_public_path__ + "static/media/cameraActive.e3d46a8c.png";